import { FeatureFlagKey } from "@swivl-mono/types";

import { isFeatureEnabled } from "./isFeatureEnabled";

/**
 * Whether this viewer gets Pulse: its page, its nav item, and the persona
 * fields on the Members page and the invite form. Pulse needs Snowy as well,
 * because everything it reads and links to is Contact Center v3 and
 * Ticketing (Mason, 2026-09-30). Every Pulse entry point asks this, never
 * one flag alone.
 */
export function isPulseEnabled(): boolean {
  return isFeatureEnabled(FeatureFlagKey.Pulse) && isFeatureEnabled(FeatureFlagKey.Snowy);
}
